export const getOfferNameForBreadcrumb = (
  offerDetailsTitle: string,
  locationTitle: string,
  confirmationTitle: string
): string => {
  // offer title can come from offerDetails module (Offer Details Page) location (Checkout Page) or confirmation module (Confirmation page)
  return offerDetailsTitle || locationTitle || confirmationTitle || "Offer";
};
